import topic from '../topic'
export const qmttAPI = {
    getQmtts: topic.qmttTopic + '/get_qmtts',
}